import {useRef} from 'react';

import {SimpleGrid} from '@mantine/core';

import {usePrices} from '../hooks/usePrices.ts';
import {usePricesSelection} from '../hooks/usePricesSelection.ts';
import {useTableColumns} from '../hooks/useTableColumns.tsx';

import {
    MantineDataTable,
    TableSearchForm,
} from '@flexinet/ui-components';
import {DataTableTokenPagination} from "../../../components/DataTableTokenPagination.tsx";

interface RecordsTableProps {
    productId?: string;
}

export const RecordsTable = ({productId}: RecordsTableProps) => {
    const {
        selectedRecords,
        setSelectedRecords
    } = usePricesSelection();
    const {columns} = useTableColumns();

    const {
        items,
        totalCount,
        loading,
        nextToken,
        fetchRecords,
        handleFilterByKeyword
    } = usePrices(productId);

    const scrollViewportRef = useRef<HTMLDivElement>(null);

    return (
        <SimpleGrid verticalSpacing='xl' m='sm'>
            <TableSearchForm handleFilterByKeyword={handleFilterByKeyword}/>

            <MantineDataTable
                columns={columns}
                records={items}
                selectedRecords={selectedRecords}
                onSelectedRecordsChange={setSelectedRecords}
                isRecordSelectable={(record) => record.priceStatus === 'Active'}
                fetching={loading}
                onScrollToBottom={() => fetchRecords()}
                scrollViewportRef={scrollViewportRef}
                withTableBorder={true}
            />

            <DataTableTokenPagination totalCount={totalCount.toString()} nextToken={nextToken}
                                      handleLoadMore={fetchRecords}/>

        </SimpleGrid>
    );
};